<template>
  <div class="upload-content">
    <div class="form-label">
      <span class="label">Sales receipt</span>
      <span class="required">*</span>
    </div>
    <van-uploader v-model="imgUrl" :after-read="(files, detail) => afterRead(files, detail, 'imgUrl')" />
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data () {
    return {
      imgUrl: []
    }
  },
  methods: {
    afterRead (files, detail, key) {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          Toast('Upload Failed')
          this.imgUrl.splice(detail.index, 1)
          // this.imgUrl.splice()
          // console.log(files, detail, key)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.upload-content {
  flex: 1;
  .form-label {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .label {
    font-size: 13px;
    font-weight: bold
  }
  .required {
    font-size: 20px;
    color: #c4200b;
    margin-left: 3px;
  }
  /deep/.van-uploader {
    .van-uploader__upload-icon {
      font-size: 20px;
    }
  }
}
</style>
